import React from "react";
import * as S from './ShortcutMenuWrapper.styles'
import { useTranslation } from "react-i18next";
import { PageTitle } from "@app/components/common/PageTitle/PageTitle";
import { useNavigate } from "react-router-dom";
import { BaseRow } from "@app/components/common/BaseRow/BaseRow";
import { BaseCol } from "@app/components/common/BaseCol/BaseCol";

export interface MenuDetailsProps {
    title: string;
    url: string;
    icon: string;
    categoryIcon: string;
    show?: boolean; 
}

export interface ShortcutDetailsProps {
    title: string;
    icon: string;
    menus: MenuDetailsProps[];
}

export interface ShortcutDetailsRef {

}

const ShortcutMenuWrapper: React.ForwardRefRenderFunction<ShortcutDetailsRef, ShortcutDetailsProps> = (
    { title, icon, menus},
    ref
) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <>
            <PageTitle>{t(title)}</PageTitle>
            <S.ShortcutWrapper>
                <S.ShortcutTitle>
                    <S.ShortcutTitleIcon src={icon} />
                    {t(title)}
                </S.ShortcutTitle>
                <S.ShortcutMenuWrapper>
                    <BaseRow gutter={[20, 20]} align="middle">
                    {menus
                            .filter(menu => menu.show !== false) // Exclude items with display set to false
                            .map((menu, index) => (
                                <BaseCol xs={12} sm={6} lg={6} xl={4} key={index}>
                                    <S.ShortcutMenuItem key={index}>
                                        <S.ShortcutMenuButton className="shortcut-menu-button" type="link" onClick={() => navigate(menu.url)}>
                                            <S.ShortcutMenuImage src={menu.icon} preview={false} />
                                            <S.ShortcutMenuItemTitle>{t(menu.title)}</S.ShortcutMenuItemTitle>
                                        </S.ShortcutMenuButton>
                                    </S.ShortcutMenuItem>
                                </BaseCol>
                            ))}
                    </BaseRow>
                </S.ShortcutMenuWrapper>
            </S.ShortcutWrapper>
        </>
    );
}

export default React.forwardRef(ShortcutMenuWrapper);